import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "tree-row parent hover:bg-slate-50"
};
const _hoisted_2 = {
  class: "px-4 py-3"
};
const _hoisted_3 = ["onClick"];
const _hoisted_4 = {
  key: 1,
  class: "w-4 h-4 flex-shrink-0"
};
const _hoisted_5 = {
  class: "text-sm font-medium text-slate-900"
};
const _hoisted_6 = {
  class: "px-4 py-3 text-sm text-slate-600"
};
const _hoisted_7 = {
  class: "px-4 py-3 text-sm text-slate-900"
};
const _hoisted_8 = {
  class: "px-4 py-3 text-sm text-slate-600"
};
const _hoisted_9 = {
  class: "px-4 py-3"
};
const _hoisted_10 = {
  key: 0,
  class: "status-badge is-success"
};
const _hoisted_11 = {
  key: 1,
  class: "status-badge is-danger"
};
const _hoisted_12 = {
  class: "px-4 py-3 data-table-sticky-right data-table-sticky-action"
};
const _hoisted_13 = {
  class: "flex items-center gap-1"
};
const _hoisted_14 = ["onClick"];
const _hoisted_15 = ["onClick"];
const _hoisted_16 = ["onClick"];
export default /*@__PURE__*/Object.assign({
  name: 'DeptTreeItem'
}, {
  __name: 'DeptTreeItem',
  props: {
    items: {
      type: Array,
      required: true
    },
    level: {
      type: Number,
      default: 0
    },
    expandedIds: {
      type: Array,
      default: () => []
    }
  },
  emits: ['toggle', 'add', 'edit', 'delete'],
  setup(__props, {
    emit: __emit
  }) {
    const emit = __emit;
    function onToggle(deptId) {
      emit('toggle', deptId);
    }
    return (_ctx, _cache) => {
      const _component_DeptTreeItem = _resolveComponent("DeptTreeItem", true);
      const _directive_permission = _resolveDirective("permission");
      return _openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, dept => {
        return _openBlock(), _createElementBlock(_Fragment, {
          key: dept.id
        }, [_createElementVNode("tr", _hoisted_1, [_createElementVNode("td", _hoisted_2, [_createElementVNode("div", {
          class: "flex items-center gap-1",
          style: _normalizeStyle({
            paddingLeft: __props.level * 24 + 'px'
          })
        }, [dept.children && dept.children.length > 0 ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: _normalizeClass(["tree-toggle w-4 h-4 text-slate-400 cursor-pointer flex-shrink-0", {
            expanded: __props.expandedIds.includes(dept.id)
          }]),
          onClick: $event => _ctx.$emit('toggle', dept.id)
        }, [...(_cache[3] || (_cache[3] = [_createElementVNode("svg", {
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M9 5l7 7-7 7"
        })], -1)]))], 10, _hoisted_3)) : (_openBlock(), _createElementBlock("span", _hoisted_4)), _cache[4] || (_cache[4] = _createElementVNode("svg", {
          class: "w-4 h-4 text-blue-500 flex-shrink-0",
          fill: "currentColor",
          viewBox: "0 0 20 20"
        }, [_createElementVNode("path", {
          "fill-rule": "evenodd",
          d: "M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z",
          "clip-rule": "evenodd"
        })], -1)), _createElementVNode("span", _hoisted_5, _toDisplayString(dept.name), 1)], 4)]), _createElementVNode("td", _hoisted_6, _toDisplayString(dept.code || '-'), 1), _createElementVNode("td", _hoisted_7, _toDisplayString(dept.sort), 1), _createElementVNode("td", _hoisted_8, _toDisplayString(dept.manager || '-'), 1), _createElementVNode("td", _hoisted_9, [dept.status ? (_openBlock(), _createElementBlock("span", _hoisted_10, [...(_cache[5] || (_cache[5] = [_createElementVNode("span", {
          class: "w-1.5 h-1.5 bg-green-500 rounded-full mr-1"
        }, null, -1), _createTextVNode("正常 ", -1)]))])) : (_openBlock(), _createElementBlock("span", _hoisted_11, [...(_cache[6] || (_cache[6] = [_createElementVNode("span", {
          class: "w-1.5 h-1.5 bg-red-500 rounded-full mr-1"
        }, null, -1), _createTextVNode("停用 ", -1)]))]))]), _createElementVNode("td", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_withDirectives((_openBlock(), _createElementBlock("button", {
          class: "table-action-button is-primary",
          title: "新增",
          "aria-label": "新增",
          onClick: $event => _ctx.$emit('add', dept)
        }, [...(_cache[7] || (_cache[7] = [_createElementVNode("svg", {
          class: "w-4 h-4",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M12 4v16m8-8H4"
        })], -1)]))], 8, _hoisted_14)), [[_directive_permission, 'org:dept:add']]), _withDirectives((_openBlock(), _createElementBlock("button", {
          class: "table-action-button is-primary",
          title: "修改",
          "aria-label": "修改",
          onClick: $event => _ctx.$emit('edit', dept)
        }, [...(_cache[8] || (_cache[8] = [_createElementVNode("svg", {
          class: "w-4 h-4",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
        })], -1)]))], 8, _hoisted_15)), [[_directive_permission, 'org:dept:edit']]), _withDirectives((_openBlock(), _createElementBlock("button", {
          class: "table-action-button is-danger",
          title: "删除",
          "aria-label": "删除",
          onClick: $event => _ctx.$emit('delete', dept)
        }, [...(_cache[9] || (_cache[9] = [_createElementVNode("svg", {
          class: "w-4 h-4",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
        })], -1)]))], 8, _hoisted_16)), [[_directive_permission, 'org:dept:remove']])])])]), dept.children && dept.children.length > 0 && __props.expandedIds.includes(dept.id) ? (_openBlock(true), _createElementBlock(_Fragment, {
          key: 0
        }, _renderList(dept.children, child => {
          return _openBlock(), _createBlock(_component_DeptTreeItem, {
            key: child.id,
            items: [child],
            level: __props.level + 1,
            "expanded-ids": __props.expandedIds,
            onToggle: onToggle,
            onAdd: _cache[0] || (_cache[0] = d => _ctx.$emit('add', d)),
            onEdit: _cache[1] || (_cache[1] = d => _ctx.$emit('edit', d)),
            onDelete: _cache[2] || (_cache[2] = d => _ctx.$emit('delete', d))
          }, null, 8, ["items", "level", "expanded-ids"]);
        }), 128)) : _createCommentVNode("", true)], 64);
      }), 128);
    };
  }
});